import { render, staticRenderFns } from "./custom-combo.vue?vue&type=template&id=174afab2&scoped=true&"
import script from "./custom-combo.vue?vue&type=script&lang=js&"
export * from "./custom-combo.vue?vue&type=script&lang=js&"
import style0 from "./custom-combo.vue?vue&type=style&index=0&id=174afab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174afab2",
  null
  
)

export default component.exports